"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_CHAMPIONSHIP: function() {
        return ADD_CHAMPIONSHIP;
    },
    DELETE_CHAMPIONSHIP: function() {
        return DELETE_CHAMPIONSHIP;
    },
    DUPLICATE_CHAMPIONSHIP: function() {
        return DUPLICATE_CHAMPIONSHIP;
    },
    GENERATE_CHAMPIONSHIPS: function() {
        return GENERATE_CHAMPIONSHIPS;
    },
    RESET_CHAMPIONSHIPS: function() {
        return RESET_CHAMPIONSHIPS;
    },
    UPDATE_CHAMPIONSHIP: function() {
        return UPDATE_CHAMPIONSHIP;
    }
});
const ADD_CHAMPIONSHIP = "ADD_CHAMPIONSHIP";
const UPDATE_CHAMPIONSHIP = "UPDATE_CHAMPIONSHIP";
const DELETE_CHAMPIONSHIP = "DELETE_CHAMPIONSHIP";
const RESET_CHAMPIONSHIPS = "RESET_CHAMPIONSHIPS";
const GENERATE_CHAMPIONSHIPS = "GENERATE_CHAMPIONSHIPS";
const DUPLICATE_CHAMPIONSHIP = "DUPLICATE_CHAMPIONSHIP";
